// Fire-and-forget logger for region/topic landing page events.
// Dual-tracks to GA4 (already wired via trackCTAClicked) AND to our own
// landing_events table so admins can see CTA performance in the dashboard.
import { isNativePlatform } from "@/lib/platform";
import { trackCTAClicked } from "@/lib/analytics";

type EventType = "cta_click" | "lead_attribution";

const FN_URL = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/log-landing-event`;

async function post(payload: Record<string, unknown>) {
  if (isNativePlatform()) return; // landings are web-only
  try {
    await fetch(FN_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // swallow — analytics must never break UX
  }
}

export function logLandingCTA(
  landing_slug: string,
  label: string,
) {
  // GA4
  trackCTAClicked(label, `landing/${landing_slug}`);
  // Internal
  void post({ event_type: "cta_click" as EventType, landing_slug, label });
}

export function logLandingAttribution(landing_slug: string, user_id: string) {
  void post({
    event_type: "lead_attribution" as EventType,
    landing_slug,
    user_id,
    label: "signup",
  });
}

const KEY = "landing_origin";

export function rememberLandingOrigin(slug: string) {
  try {
    if (!sessionStorage.getItem(KEY)) sessionStorage.setItem(KEY, slug);
  } catch {}
}

export function consumeLandingOrigin(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) sessionStorage.removeItem(KEY);
    return v;
  } catch {
    return null;
  }
}
